<template>
  <a-card :bordered="false">
    <a-table
      v-if="false"
      :columns="columns"
      :data-source="data"
      :pagination="false"
    >
      <a slot="name" slot-scope="text">{{ text }}</a>
    </a-table>
    <a-row :gutter="24" class="chatmass-texting-box">
      <a-col :span="5" :xs="4">
        <a-card
          hoverable
          class="Addmaterial texting-card chatmass-texting-add__btn"
          @click="handleAdd"
        >
          <a-icon key="plus" type="plus" />
          <p class="chatmass-texting-add__desc">添加群发素材</p>
        </a-card>
      </a-col>
      <a-col :span="5" :xs="4" v-for="item in material" :key="item.id">
        <a-card :bordered="false" hoverable class="texting-card">
          <div class="examine">
            <!-- 审核中 -->
            <a-tag v-if="item.status == 1 || item.status == 2" color="#ccc"
              >审核中</a-tag
            >
            <!-- 审核拒绝 -->
            <a-tag v-if="item.status == 4" color="red">审核拒绝</a-tag>

            <!-- 审核通过 -->
            <a-tag v-if="item.status == 3" color="blue">审核通过</a-tag>
          </div>

          <div>
            <div class="texting-card-text-box">
              <p>{{ item.document }}</p>
            </div>
            <img
              v-if="item.imgpicurl"
              class="imgpicurl"
              alt="example"
              :src="item.imgpicurl"
            />
            <div
              class="texting-card-img-box linkImg"
              v-else-if="item.linktitle"
            >
              <p>{{ item.linktitle }}</p>
              <div class="flex bottom-content">
                <div class="flex_1">
                  {{ item.linkdesc }}
                </div>
                <img
                  v-if="item.linkpicurl"
                  class="linkpicurl"
                  alt="example"
                  :src="item.linkpicurl"
                />
              </div>
            </div>
            <div class="texting-card-img-box linkImg" v-if="item.minititle">
              <p>{{ item.minititle }}</p>
              <div class="flex bottom-content">
                <div class="flex_1">
                  {{ item.miniappid }}
                </div>
                <img
                  v-if="item.minipicmediaid"
                  class="linkpicurl"
                  alt="example"
                  :src="item.programUrl"
                />
              </div>
            </div>
          </div>
          <template
            v-if="item.status != 1 && item.status != 2"
            slot="actions"
            class="ant-card-actions"
          >
            <a-icon @click="deleteMoadl(item.id)" key="delete" type="delete" />
            <a-icon @click="handleAddValue(item)" key="edit" type="edit" />
            <span @click="texting(item.id)" v-if="item.status == 3">群发</span>
            <span @click="history(item)" v-if="item.status == 3">历史</span>
          </template>
        </a-card>
      </a-col>
    </a-row>
    <!-- 群发 -->
    <a-drawer
      title="群发"
      placement="right"
      :closable="false"
      :visible="Visible"
      @close="CloseTexting"
      width="800"
    >
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="客户群发">
          <wx-customer-send-list
            @close="CloseTexting"
            v-model="sendMaterialId"
          ></wx-customer-send-list>
        </a-tab-pane>
        <a-tab-pane key="2" tab="客户群群发" force-render>
          <customer-group-send-list
            v-model="sendMaterialId"
          ></customer-group-send-list>
        </a-tab-pane>
      </a-tabs>
    </a-drawer>

    <!-- 群发历史 -->
    <a-drawer
      title="群发历史"
      placement="right"
      :closable="false"
      :visible="historyVisible"
      @close="historyClose"
      width="800"
    >
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="客户群发">
          <a-table
            ref="table"
            bordered
            size="middle"
            :columns="hiscolumnsclients"
            :dataSource="historyListClients"
          >
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="客户群群发">
          <a-table
            ref="table"
            bordered
            size="middle"
            :columns="hiscolumnsgroups"
            :dataSource="historyListGroups"
          >
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-drawer>
    <text-Moadl ref="modalForm" @ok="modalFormOk"></text-Moadl>
  </a-card>
</template>
<script>
import { getAction, postAction } from '@/api/manage';
import TextMoadl from './modules/TextingMoadl.vue';
import JImageUpload from '@/components/jeecg/JImageUpload';
import { getLabelAll, getCusAll } from '@/api/api';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import WxCustomerSendList from './wxCustomerSendList.vue';
import CustomerGroupSendList from './CustomerGroupSendList.vue';

const columns = [
  {
    title: '本月剩余群发次数',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '0次',
    dataIndex: 'zero',
    key: 'zero',
  },
  {
    title: '1次',
    dataIndex: 'one',
    key: 'one',
  },
  {
    title: '2次',
    dataIndex: 'two',
    key: 'two',
  },
  {
    title: '3次',
    dataIndex: 'thiree',
    key: 'thiree',
  },
  {
    title: '4次',
    dataIndex: 'four',
    key: 'four',
  },
];

const data = [
  {
    key: '1',
    name: '客户数',
    zero: 56546545,
    one: 23,
    two: 213,
    thiree: 16552,
    four: 1655,
  },
];

export default {
  mixins: [JeecgListMixin],
  components: {
    JImageUpload,
    TextMoadl,
    WxCustomerSendList,
    CustomerGroupSendList,
  },
  data() {
    return {
      clientcolumns: [
        {
          title: '客户名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '客户标签',
          dataIndex: 'zero',
          key: 'zero',
        },
        {
          title: '添加人',
          dataIndex: 'one',
          key: 'one',
        },
        {
          title: '添加时间',
          dataIndex: 'two',
          key: 'two',
        },
        {
          title: '剩余群发次数',
          dataIndex: 'thiree',
          key: 'thiree',
        },
      ],
      visibleshowuser: false,
      url: {
        list:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/wechatMsg/getMaterial',
        history:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/wechatMsg/getByMatIdRecord',
        delMaterial:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/wechatMsg/delMaterial',
        clientData:
          process.env.VUE_APP_CMS_WECHATCUSTOMER + '/wechatwork/client/data',
        listAll:
          process.env.VUE_APP_CMS_WECHATCUSTOMER +
          '/wechatwork/customerGroupChat/data',
      },
      data,
      columns,
      historyListClients: [],
      historyListGroups: [],
      acrticeURL: '',
      acrticeTitle: '',
      digest: '',
      coverPic: '',
      clientData: [],
      headers: {
        authorization: 'multipart/form-data',
      },
      popovernDrawer: false,
      popoverVisible: false,
      hiscolumnsclients: [
        {
          title: '发送时间',
          dataIndex: 'sendTime',
          key: 'sendTime',
        },
        {
          title: '接收客户',
          dataIndex: 'sum',
          key: 'sum',
        },
        // {
        //   title: '客户标签',
        //   dataIndex: 'one',
        //   key: 'one',
        // },
        {
          title: '相关员工',
          dataIndex: 'name',
          key: 'name',
        },
      ],
      hiscolumnsgroups: [
        {
          title: '发送时间',
          dataIndex: 'sendTime',
          key: 'sendTime',
        },
        {
          title: '接收客户群',
          dataIndex: 'sum',
          key: 'sum',
        },
        {
          title: '群成员统计',
          dataIndex: 'memberNum',
          key: 'memberNum',
        },
        {
          title: '群主',
          dataIndex: 'name',
          key: 'name',
        },
      ],
      sendTime: '',
      childrenDrawer: false,
      Visible: false,
      historyVisible: false,
      deleteStatus: false,
      tableList: [],
      startTime: '',
      endTime: '',
      added: '', //添加人
      clientTag: '',
      departTree: [],
      checkedKeys: [], // 存储选中的部门id
      expandedKeysss: [],
      material: [],
      deleteid: '', //要删除的id
      sendMaterialId: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    modalFormOk() {
      this.getData();
    },
    loadData() {
      return false;
    },
    getData() {
      getAction(this.url.list, {}).then((res) => {
        if (res.success) {
          this.material = res.result;
          this.material.forEach((item) => {
            item.programUrl =
              process.env.VUE_APP_CMS_MINIOURL + item.programUrl;
          });
          console.log(this.material);
        }
      });
    },
    howuseradded() {
      this.departTree = [];
      this.visibleshowuser = true;
      getCusAll().then((res) => {
        if (res.success) {
          this.departTree = res.result;
          if (this.checkedKeys && this.checkedKeys.length > 0) {
            let treekey = [];
            let arr = res.result;
            if (arr && arr.length > 0) {
              arr.forEach((item) => {
                treekey.push(item.key);
              });
              this.expandedKeysss = treekey;
            }
          }
        }
      });
    },
    onClose() {
      this.visibleshowuser = false;
    },
    onExpand(expandedKeys) {
      this.expandedKeysss = expandedKeys;
    },
    onCheck(checkedKeys, info) {
      this.departList = [];
      this.checkedKeys = checkedKeys.checked;
      let checkedNodes = info.checkedNodes;
      for (let i = 0; i < checkedNodes.length; i++) {
        let de = checkedNodes[i].data.props;
        let depart = {
          key: '',
          value: '',
          title: '',
          parentName: '',
        };
        depart.key = de.value;
        depart.value = de.value;
        depart.title = de.title;
        depart.parentName = de.dataRef.parentid;
        this.departList.push(depart);
      }
      console.log('onCheck', checkedKeys, info);
    },
    popoverDrawer() {
      this.popovernDrawer = true;
    },
    popoverDrawerClose() {
      this.popovernDrawer = false;
    },
    hide() {
      this.popoverVisible = false;
    },
    onChildrenDrawerClose() {
      this.childrenDrawer = false;
    },
    callback(key) {
      console.log(key);
    },
    ClickclientTag() {
      this.departTree = [];
      this.childrenDrawer = true;
      getLabelAll().then((res) => {
        if (res.success) {
          this.departTree = res.result;
          if (this.checkedKeys && this.checkedKeys.length > 0) {
            let treekey = [];
            let arr = res.result;
            if (arr && arr.length > 0) {
              arr.forEach((item) => {
                treekey.push(item.key);
              });
              this.expandedKeysss = treekey;
            }
          }
          su;
        }
      });
    },
    changeTime(value, dateStrings) {
      this.startTime = dateStrings[0];
      this.endTime = dateStrings[1];
    },
    texting(id) {
      sessionStorage.setItem('groupSendMaterialId', id);
      this.Visible = true;
      this.sendMaterialId = id + '';
    },
    CloseTexting() {
      this.Visible = false;
      this.departList = [];
      this.checkedKeys = [];
    },
    history(item) {
      postAction(this.url.history, {
        id: item.id,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.historyListClients = res.result.chatMsgRecordInfoClient;
          this.historyListGroups = res.result.chatMsgRecordInfoGroup;
        }
      });
      this.historyVisible = true;
    },
    historyClose() {
      this.historyVisible = false;
    },
    deleteMoadl: function (id) {
      let that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function () {
          getAction(that.url.delMaterial, {
            id: id,
          }).then((res) => {
            that.getData();
          });
        },
      });
    },
  },
};
</script>

<style>
.linkImg {
  background-color: #efefef;
}

.flex {
  display: flex;
}

.flex_1 {
  display: flex;
  flex: 1;
}

.imgpicurl {
  height: 120px;
  width: 100%;
}

.texting-card {
  padding: 0;
  height: 290px;
  /* overflow: hidden; */
  margin: 16px 0 16px 0;
  display: flex;
  flex-flow: column;
  align-items: center;
  border-radius: 4px;
  box-shadow: 0px 1px 6px rgb(0 0 0 / 10%);
}

.link {
  height: 200px;
}

.texting-card-img-box {
  overflow: hidden;
  padding: 5px 10px;
}

.texting-card-img-box .linkpicurl {
  width: 40px;
  height: 40px;
  line-height: 48px;
}

.texting-card-img-box p {
  width: 100%;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  word-break: break-all;
  word-wrap: break-word;
  color: #333;
  font-size: 15px;
  margin: 0 0 5px 0;
}

.texting-card-img-box img {
  width: 100%;
}

.bottom-content .flex_1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
  word-wrap: break-word;
  width: 100%;
  line-height: 1.2;
}

.chatmass-texting-box .ant-card-body {
  padding: 0;
  flex: auto;
  width: 100%;
}

.chatmass-texting-box .ant-card-body > div {
  display: flex;
  flex-flow: column;
  align-items: center;
  height: 100%;
}

.chatmass-texting-box .ant-card-body .texting-card-img-box {
  flex: none;
  width: 100%;
}

.texting-card-text-box {
  font-size: 18px;
  flex: auto;
  width: 100%;
  padding: 15px;
  padding-top: 30px;
}

.texting-card-text-box p {
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
  word-wrap: break-word;
  font-size: 14px;
}

.texting-card .ant-card-actions {
  flex: none;
  width: 100%;
}

.chatmass-texting-add__btn .ant-card-body {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chatmass-texting-add__desc {
  margin: 0;
}
.examine {
  position: absolute;
  top: 5px;
  right: -2px;
}
</style>
